const { hostname } = window.location;

const IN_PRODUCTION =
  hostname === 'connect.inventorum.com' || hostname === 'manager.shore.com';
const ENV_CORE_URL = IN_PRODUCTION
  ? 'https://app.inventorum.com'
  : 'https://app-aws.inventorum.com';
const URL = hostname === 'localhost' ? '' : ENV_CORE_URL;

const config = {
  ENV: process.env.NODE_ENV,
  SAGE_SERVICE_API: process.env.REACT_APP_SAGE_SERVICE_API || '/sageone/api',
  SHORE_APP_URL: 'https://my.shore.com',
  USERLANE_APP_ID: '7lq28',
  PAYMENT_SITE_URL: IN_PRODUCTION
    ? 'https://site.inventorum.com/de/pay/'
    : 'https://site-aws.inventorum.com/de/pay/',
  CHARGEBEE_URL: IN_PRODUCTION
    ? 'https://subscription-app.shore-internal.com'
    : 'https://subscription-app-staging.shore-internal.com',
  SUBSCRIPTION_APP_URL: IN_PRODUCTION
    ? 'https://api.shore.com'
    : 'https://api-staging.shore.com',
  CORE_URL: URL,
  DASHBOARD_PLUS_URL: IN_PRODUCTION
    ? 'https://dashboard-plus.shore.com'
    : 'https://dashboard-plus-staging.shore.com',
  TRIAL_SUBSCRIPTION_ID: 10,
  HOSTNAME: hostname,
  IN_PRODUCTION,
  IN_DEV: hostname === 'localhost',
};

export default config;
